export type OfacLanguage = 'en' | 'es';

type CopyBlock = { en: string; es: string };

export const ofacPlanCoverageText = (language: OfacLanguage, block: CopyBlock): string => (
  language === 'es' ? block.es : block.en
);

export const OFAC_PLAN_COVERAGE_COPY = {
  kicker: {
    en: 'Coverage by subscription',
    es: 'Cobertura por suscripción',
  },
  title: {
    en: 'OFAC client-file coverage scales with CompliCore, CompliAdvantage, and CompliComplete',
    es: 'La cobertura OFAC del archivo de clientes escala con CompliCore, CompliAdvantage y CompliComplete',
  },
  help: {
    en: 'OFAC does not publish one scan interval (FAQ 28). FFIEC still expects new names before the relationship starts, the existing book when lists change, and payment parties before funds move. NextCompli gates automation to the plan; the legal duty to screen named parties does not go away on CompliCore.',
    es: 'OFAC no publica un intervalo único de barrido (FAQ 28). FFIEC igual espera nombres nuevos antes de abrir la relación, el libro existente cuando cambian las listas, y las partes de pago antes de mover fondos. NextCompli limita la automatización al plan; el deber legal de cribar partes nombradas no desaparece en CompliCore.',
  },
  lead: {
    en: 'CompliCore is named-party onboard plus an operator rescreen when Live Feed / GovDelivery shows a list update. CompliAdvantage auto-rescreens the book, adds CSV and payment-party batch, and starts a 10-business-day block/reject clock. CompliComplete adds tested sanctions-program evidence. A CLEAR on a named party is not clearance of unnamed 50% affiliates or a general license’s conditions.',
    es: 'CompliCore es alta de partes nombradas más un re-cribado del operador cuando el feed en vivo / GovDelivery muestra una actualización de listas. CompliAdvantage re-criba el libro, añade lote CSV y de pagos, y arranca un reloj de 10 días hábiles de bloqueo/rechazo. CompliComplete añade evidencia auditada del programa de sanciones. Un CLEAR de una parte nombrada no limpia afiliados del 50% sin nombre ni las condiciones de una licencia general.',
  },
  plans: [
    {
      id: 'core',
      name: { en: 'CompliCore · Screen', es: 'CompliCore · Screen' },
      price: { en: '$99/mo starting', es: 'desde $99/mes' },
      body: {
        en: 'Customers, vendors, payees, employees, and contractors: Screen now at onboard. After an OFAC notice, the operator runs Rescreen book. Identifiers (date of birth / ID) make a CLEAR durable. SDN is never skipped for a hire.',
        es: 'Clientes, proveedores, beneficiarios, empleados y contratistas: Screen now al dar de alta. Tras un aviso OFAC, el operador ejecuta Re-cribar cartera. Identificadores (fecha de nacimiento / ID) hacen duradero un CLEAR. SDN nunca se omite en una contratación.',
      },
    },
    {
      id: 'advantage',
      name: { en: 'CompliAdvantage · Monitor', es: 'CompliAdvantage · Monitor' },
      price: { en: '$999/mo starting', es: 'desde $999/mes' },
      body: {
        en: 'Same named parties, plus automatic portfolio rescreen when Treasury mail kicks a list refresh. CSV / payment-party batch before funds move. Hits open an incident with a 10-business-day reporting prompt. Ownership investigations run across the book.',
        es: 'Las mismas partes nombradas, más re-cribado automático de la cartera cuando el correo del Tesoro dispara una recarga de listas. Lote CSV / parte de pago antes de mover fondos. Los hits abren un incidente con aviso de reporte a 10 días hábiles. Las investigaciones de propiedad corren sobre el libro.',
      },
    },
    {
      id: 'complete',
      name: { en: 'CompliComplete · Govern', es: 'CompliComplete · Govern' },
      price: { en: 'Contact for estimate', es: 'Contactar para estimado' },
      body: {
        en: 'Same controls, branded as the client sanctions program. Embedded consultant, executive reporting, case/audit workspace, and independent sample tests of the matcher. Blocking property and filing remain the client’s duty.',
        es: 'Los mismos controles, con la marca del programa de sanciones del cliente. Consultor integrado, reportes ejecutivos, espacio de casos/auditoría y pruebas independientes del matcher. Bloquear bienes y presentar reportes sigue siendo deber del cliente.',
      },
    },
  ],
  disclaimer: {
    en: 'NextCompli is the control system, not OFAC counsel. SLS remains the source of record for list files; GovDelivery email only kicks the refresh.',
    es: 'NextCompli es el sistema de control, no un abogado de OFAC. SLS sigue siendo la fuente oficial de los archivos de listas; el correo GovDelivery solo dispara la recarga.',
  },
} as const;
